import { type ReactNode } from 'react';

interface CompanyInfoItemProps {
  icon: ReactNode;
  label: string;
  value: string | null | undefined;
  isLink?: boolean;
  className?: string;
}

export const CompanyInfoItem = ({ icon, label, value, isLink = false, className = '' }: CompanyInfoItemProps) => {
  const displayValue = value && value.trim() !== '' ? value : '-';

  // For links, strip protocol for display and add www. prefix if not present
  let displayText = displayValue;
  if (isLink && value) {
    const stripped = value.replace(/^https?:\/\//, '');
    displayText = stripped.startsWith('www.') ? stripped : `www.${stripped}`;
  }

  // Ensure URL has protocol
  const href = isLink && value
    ? (value.startsWith('http') ? value : `https://${value}`)
    : undefined;

  return (
    <div className={`flex items-start gap-3 ${className}`} role="group" aria-label={label}>
      {/* Icon container with background */}
      <div className="flex items-center justify-center w-11 h-11 p-3 bg-[#F8FAFC] rounded-lg flex-shrink-0">
        <div className="text-[#62748E]">{icon}</div>
      </div>

      {/* Label and value */}
      <div className="flex flex-col gap-1">
        <span className="font-['Inter'] font-normal text-xs leading-4 uppercase text-[#62748E]">{label}</span>
        {isLink && value ? (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="font-['Inter'] font-normal text-xs leading-4 text-[#006FEE]"
            aria-label={`Visit ${value}`}
          >
            {displayText}
          </a>
        ) : (
          <span className="font-['Inter'] font-medium text-sm leading-5 text-[#0F172B]">{displayValue}</span>
        )}
      </div>
    </div>
  );
};
